export const contractTypeOptions = [
  // { title: '草稿', value: 0 },
  // { title: '待估价', value: 1 },
  // { title: '待确认', value: 2 },
  // { title: '已核价', value: 3 }
  { title: '转估价', value: 0 },
  { title: '估价中', value: 1 },
  { title: '已估价', value: 2 }
]

export const contractTypeListOptions = [
  { title: '未转估价', value: 0 },
  { title: '待领取', value: 1 },
  { title: '估价中', value: 2 },
  { title: '已估价', value: 3 }
]

export const estimateStatusListOptions = [
  { title: '估价中', value: 2 },
  { title: '已估价', value: 3 }
]


export const statusFinanceOptions = [
  { title: '审核中', value: 1 },
  { title: '已审核', value: 2 },
  { title: '财务拒绝', value: 3 }
]

export const statusGroupOptions = [
  { title: '审核中', value: 1 },
  { title: '已审核', value: 2 },
  { title: '集团拒绝', value: 3 }
]

export const statusFinanceListOptions = [
  { title: '未转财务', value: 0 },
  { title: '审核中', value: 1 },
  { title: '已审核', value: 2 },
  { title: '财务拒绝', value: 3 }
]

export const statusGroupListOptions = [
  { title: '未转集团', value: 0 },
  { title: '审核中', value: 1 },
  { title: '已审核', value: 2}
]

export const statusDesignListOptions = [
  { title: '未转设计', value: 0 },
  // { title: '待领取', value: 1 },
  { title: '设计中', value: 1 },
  { title: '已设计', value: 2 }
]

export const designStatusListOptions = [
  { title: '未转设计', value: 0 },
  { title: '待领取', value: 1 },
  { title: '设计中', value: 2 },
  { title: '已设计', value: 3 }
]

export const statusDesignedListOptions = [
  { title: '设计中', value: 2 },
  { title: '已设计', value: 3 }
]

export const statusAuditListOptions = [
  { title: '-', value: 0 },
  { title: '待审核', value: 1 },
  { title: '已审核', value: 2 },
  { title: '已拒绝', value: 3 }
]

export const statusWuLiaoedListOptions = [
  { title: '待领取', value: 1 },
  { title: '物控中', value: 1 },
  { title: '已物控', value: 2 }
]

export const statusWuLiaoListOptions = [
  { title: '未转物控', value: 0 },
  // { title: '待领取', value: 1 },
  { title: '物控中', value: 1 },
  { title: '已物控', value: 2 }
]

export const wuliaoStatusListOptions = [
  { title: '待领取', value: 1 },
  { title: '物控中', value: 2 },
  { title: '已物控', value: 3 },
  { title: '业务拒绝', value: 4 },
  { title: '业务待确认', value: 5 }
]

export const wuliaoStatusedListOptions = [
  { title: '物控中', value: 2 },
  { title: '已物控', value: 3 },
  { title: '业务拒绝', value: 4 },
  { title: '业务待确认', value: 5 }
]

export const estStatusListOptions = [
  { title: '待领取', value: 1 },
  { title: '估价中', value: 2 },
  { title: '已估价', value: 3 }
]

export const deStatusListOptions = [
  { title: '待领取', value: 1 },
  { title: '设计中', value: 2 },
  { title: '已设计', value: 3 }
]

export const statusDesignOptions = [
  { title: '待设计', value: 1 },
  // { title: '设计中', value: 2 },
  { title: '已设计', value: 2 }
]

export const statusWuLiaoOptions = [
  { title: '待物控', value: 1 },
  // { title: '物控中', value: 2 },
  { title: '已物控', value: 2 }
]

export const projectTypeOptions = [
  { title: '酒店', value: '酒店' },
  { title: '连锁店', value: '连锁店' },
  { title: '餐饮', value: '餐饮' },
  { title: '个人', value: '个人' },
  { title: '固定家具', value: '固定家具' },
  { title: '样品', value: '样品' },
  { title: '维修', value: '维修' }
]

// export const materialTypeOptions = [
//   { title: '板材类', value: '板材类' },
//   { title: '包材类', value: '包材类' },
//   { title: '玻璃类', value: '玻璃类' },
//   { title: '布类', value: '布类' },
//   { title: '大理石', value: '大理石' },
//   { title: '刀具类', value: '刀具类' },
//   { title: '灯具类', value: '灯具类' },
//   { title: '封边条', value: '封边条' },
//   { title: '胶水类', value: '胶水类' },
//   { title: '金属类', value: '金属类' },
//   { title: '木皮类', value: '木皮类' },
//   { title: '泡棉类', value: '泡棉类' },
//   { title: '皮革类', value: '皮革类' },
//   { title: '沙发辅料类', value: '沙发辅料类' },
//   { title: '实木类', value: '实木类' },
//   { title: '维修类', value: '维修类' },
//   { title: '小五金', value: '小五金' },
//   { title: '研磨类', value: '研磨类' },
//   { title: '油漆类', value: '油漆类' }
// ]


export const bigClassOptions = [
  { title: '基材', value: '基材' },
  { title: '油漆', value: '油漆' },
  { title: '小五金', value: '小五金' },
  { title: '玻璃', value: '玻璃' },
  { title: '石材', value: '石材' },
  { title: '面料', value: '面料' },
  { title: '外购件', value: '外购件' },
  { title: '大五金', value: '大五金' },
  { title: '差价', value: '差价' }
]

// 根据大类获取对应的材料类型选项
export const getMaterialTypeOptions = (bigClass: string) => {
  const materialTypeMap: Record<string, Array<{ title: string; value: string }>> = {
    '基材': [
      { title: '板材类', value: '板材类' },
      { title: '包材类', value: '包材类' },
      { title: '刀具类', value: '刀具类' },
      { title: '封边条', value: '封边条' },
      { title: '胶水类', value: '胶水类' },
      { title: '木皮类', value: '木皮类' },
      { title: '泡棉类', value: '泡棉类' },
      { title: '沙发辅料类', value: '沙发辅料类' },
      { title: '实木类', value: '实木类' },
      { title: '维修类', value: '维修类' },
      { title: '研磨类', value: '研磨类' },
      { title: '杂项', value: '杂项' }
    ],
    '油漆': [
      { title: '油漆类', value: '油漆类' }
    ],
    '小五金': [
      { title: '灯具类', value: '灯具类' },
      { title: '小五金', value: '小五金' }
    ],
    '玻璃': [
      { title: '玻璃类', value: '玻璃类' }
    ],
    '石材': [
      { title: '大理石', value: '大理石' },
      { title: '岩板', value: '岩板' },
      { title: '人造石', value: '人造石' }
    ],
    '面料': [
      { title: '布类', value: '布类' },
      { title: '皮革类', value: '皮革类' }
    ],
    '外购件': [
      { title: '外购类', value: '外购类' }
    ],
    '大五金': [
      { title: '金属类', value: '金属类' }
    ],
    '差价': [
      { title: '差价', value: '差价' }
    ]
  }
  
  return materialTypeMap[bigClass] || []
}

export const productBigClassOptions = [
  { title: '成品', value: '成品' },
  { title: '费用', value: '费用' }
]

// 成品类型选项
export const getProductTypeOptions = (bigClass: string) => {
  const productTypeMap: Record<string, Array<{ title: string; value: string }>> = {
    '成品': [
      { title: '成品', value: '成品' },
      { title: '工具类', value: '工具类' }
    ],
    '费用': [
      { title: '费用', value: '费用' },
      { title: '安装费', value: '安装费' },
      { title: '折让费用', value: '折让费用' },
      { title: '样品费', value: '样品费' },
      { title: '运费', value: '运费' },
      { title: '模具费', value: '模具费' },
      { title: '木箱费', value: '木箱费' }
    ]
  }
  return productTypeMap[bigClass] || []
}

export const materialTypeOptions = [
  { title: '板材类', value: '板材类' },
  { title: '包材类', value: '包材类' },
  { title: '刀具类', value: '刀具类' },
  { title: '封边条', value: '封边条' },
  { title: '胶水类', value: '胶水类' },
  { title: '木皮类', value: '木皮类' },
  { title: '泡棉类', value: '泡棉类' },
  { title: '沙发辅料类', value: '沙发辅料类' },
  { title: '实木类', value: '实木类' },
  { title: '维修类', value: '维修类' },
  { title: '研磨类', value: '研磨类' },
  { title: '杂项', value: '杂项' },
  { title: '油漆类', value: '油漆类' },
  { title: '灯具类', value: '灯具类' },
  { title: '小五金', value: '小五金' },
  { title: '玻璃类', value: '玻璃类' },
  { title: '大理石', value: '大理石' },
  { title: '岩板', value: '岩板' },
  { title: '人造石', value: '人造石' },
  { title: '布类', value: '布类' },
  { title: '皮革类', value: '皮革类' },
  { title: '外购类', value: '外购类' },
  { title: '金属类', value: '金属类' },
  { title: '差价', value: '差价' }
]

export const wuliaoTypeOptions = [
  { title: '样品', value: '样品' },
  { title: '大货', value: '大货' },
  { title: '固装', value: '固装' },
  { title: '公区', value: '公区' }
]

export const materialUnitOptions = [
  { title: 'KG', value: 'KG' },
  { title: 'KPCS', value: 'KPCS' },
  { title: 'M', value: 'M' },
  { title: 'PCS', value: 'PCS' },
  { title: 'SET', value: 'SET' },
  { title: '个', value: '个' },
  { title: '盒', value: '盒' },
  { title: '卷', value: '卷' },
  { title: '立方', value: '立方' },
  { title: '米', value: '米' },
  { title: '平方', value: '平方' },
  { title: '桶', value: '桶' },
  { title: '英尺', value: '英尺' },
  { title: '只', value: '只' },
  { title: '组', value: '组' }
]

import processStatus16 from '@/assets/16.png'
import processStatus17 from '@/assets/17.png'
import processStatus11 from '@/assets/11.png'
import processStatus12 from '@/assets/12.png'
import processStatus13 from '@/assets/13.png'
import processStatus14 from '@/assets/14.png'
import processStatus15 from '@/assets/15.png'
import processStatus9 from '@/assets/9.png'
import processStatus10 from '@/assets/10.png'
import processStatus6 from '@/assets/6.png'
import processStatus7 from '@/assets/7.png'
import processStatus8 from '@/assets/8.png'
import processStatus3 from '@/assets/3.png'
import processStatus29 from '@/assets/29.png'
import processStatus30 from '@/assets/30.png'
import processStatus31 from '@/assets/31.png'
import processStatus32 from '@/assets/32.png'
import processStatus33 from '@/assets/33.png'

export const processStatusOptions = [
  { title: '备料', image: processStatus16, width: 66, height: 28 },
  { title: '机加工', image: processStatus17, width: 110, height: 28 },
  { title: '白坯首件', image: processStatus11, width: 110, height: 28 },
  { title: '白坯组装', image: processStatus12, width: 110, height: 28 },
  { title: '白磨', image: processStatus13, width: 110, height: 28 },
  { title: '油漆', image: processStatus14, width: 110, height: 28 },
  { title: '来料检验', image: processStatus15, width: 110, height: 28 },
  { title: '软包首件', image: processStatus9, width: 110, height: 28 },
  { title: '软包批量', image: processStatus10, width: 110, height: 28 },
  { title: '成品首件', image: processStatus6, width: 110, height: 28 },
  { title: '成品批量', image: processStatus7, width: 110, height: 28 },
  { title: '出货', image: processStatus8, width: 110, height: 28 },
  { title: '客服', image: processStatus3, width: 110, height: 28 },
  { title: '表面处理', image: processStatus29, width: 100, height: 28 },
  { title: '送货', image: processStatus30, width: 66, height: 28 },
  { title: '下料', image: processStatus31, width: 66, height: 28 },
  { title: '焊接', image: processStatus32, width: 66, height: 28 },
  { title: '打磨', image: processStatus33, width: 66, height: 28 },
]
